import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { slugify } from '@surfline/web-common';
import { spotReportPath } from '@surfline/web-common/dist/paths/kbyg';
import SpotMap from '../../SpotMap';
import SpotList from '../../SpotList';
import MapPageMeta from '../../../components/MapPageMeta';
import { scrollToSpot } from '../../../actions/animations';
import { goToUsersNearestSpot, setMapLocation } from '../../../actions/map';
import { navigatedToPage } from '../../../actions/segmentEvents';
import mapOptions from '../../../utils/mapOptions';
import { getMapPageHeight, getMapPageWidth } from '../../../utils/dimensions';
import { ALWAYS_SYNC } from '../../../propTypes/map/mapUrlSync';

class Map extends Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        location: PropTypes.string,
      }),
    }).isRequired,
    doSetMapLocation: PropTypes.func.isRequired,
    doGoToUsersNearestSpot: PropTypes.func.isRequired,
    doScrollToSpot: PropTypes.func.isRequired,
    doNavigatedToPage: PropTypes.func.isRequired,
    history: PropTypes.shape({ push: PropTypes.func }).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      mapPageHeight: {
        height: '0px',
      },
    };

    const { doNavigatedToPage } = this.props;
    doNavigatedToPage('Map', {
      category: 'cams & forecasts',
      channel: 'cams & forecasts',
    });
  }

  // Initializes map location in redux store on initial load
  componentDidMount() {
    const { match, doSetMapLocation, doGoToUsersNearestSpot } = this.props;
    this.setMapPageHeight();
    const sessionLocation = JSON.parse(sessionStorage.getItem('slMapLocation') || null);
    const pathLocation = match.params.location && match.params.location.split(',');
    const location = pathLocation
      ? {
          center: {
            lat: Number(pathLocation[0]),
            lon: Number(pathLocation[1]),
          },
          zoom: pathLocation[2] && Number(pathLocation[2].replace('z', '')),
        }
      : sessionLocation;

    if (location) doSetMapLocation(location);
    else doGoToUsersNearestSpot(true);

    if (document) document.body.classList.add('sl-hide-ze-widget');
  }

  componentWillUnmount() {
    if (document) document.body.classList.remove('sl-hide-ze-widget');
  }

  setMapPageHeight = () => {
    this.setState({ mapPageHeight: getMapPageHeight() });
  };

  goToSpot = spot => {
    const { history } = this.props;
    return history.push(spotReportPath(slugify(spot.name), spot._id));
  };

  render() {
    const { mapPageHeight } = this.state;
    const { doScrollToSpot } = this.props;
    return (
      <div className="sl-map-page" style={mapPageHeight}>
        <MapPageMeta />
        <div className="sl-right-rail">
          <SpotMap
            showBottomControls
            mapOptions={mapOptions}
            clusterMaxZoom={11}
            onClickSpotMarker={getMapPageWidth() < 992 ? doScrollToSpot : this.goToSpot}
            syncUrl={ALWAYS_SYNC}
            storeLocationInSession
          />
        </div>
        <div className="sl-left-rail">
          <SpotList />
        </div>
      </div>
    );
  }
}

export default connect(
  () => ({}),
  dispatch => ({
    doSetMapLocation: location => dispatch(setMapLocation(location, true, true)),
    doGoToUsersNearestSpot: syncUrl => dispatch(goToUsersNearestSpot(syncUrl)),
    doScrollToSpot: spot => dispatch(scrollToSpot(spot._id)),
    doNavigatedToPage: (name, properties) => dispatch(navigatedToPage(name, properties)),
  })
)(Map);
